<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners"></div>

     <div class="c-container">
       <div class="dh-content">
				<h1>防沉迷系统</h1>
				<p><span>特别提示：</span>本网络棋牌游戏用户适合18岁以上（含18岁）用户，如您未满18周岁，将不被允许您注册和使用本网络游戏。您注册和使用的北京北京博久网络科技有限公司通行证的身份证信息必须真实有效。</p>
				<p>欢迎申请使用北京博久网络科技有限公司有限公司（以下简称“北京博久”）提供的在线网络棋牌游戏服务，为了保障用户的权益，请详细阅读本网络游戏使用协议(以下简称《条款》)的所有内容。本《条款》系由用户与本公司就本网络棋牌游戏产品及服务所订立的协议。</p>
				<p>当用户在线点击“同意”键时，则应视为用户已经详细阅读了本《条款》的内容，并同意遵守本条款的规定。</p>
				<p>另外提醒用户，本《条款》之规定有时可能会更改，本《条款》一旦发生变动，将会在该款网络游戏的重要页面上提示变更内容。如果用户不同意本公司变更的内容，用户可以主动取消获得的网络服务。如果用户在变更内容公告后15天内未主动取消服务，则视为接受条款的变更；变更内容公告后用户如果仍继续使用本公司提供的产品和服务亦构成对条款变更的接受。</p>
				<p>《北京博久网络科技有限公司用户信息保密政策》系明确约定本公司对于用户使用本公司网络服务而提供和产生的信息承担一定保密义务的政策，是本协议的重要组成部分。请您务必仔细阅读《北京北京博久网络科技有限公司用户信息保密政策》，对本协议的同意即视为对《北京博久网络科技有限公司用户信息保密政策》的同意。</p>
				<p class="title">第一条&nbsp;游戏说明</p>
				<p>本《条款》所述网络游戏分别代指本公司推出的各款多人在线网络游戏（亦包括网页游戏），各款网络游戏均独立适用本《条款》约束。本用户条款的目的是规范游戏用户注册、使用帐号，参与本网络游戏等各项行为。</p>
				<p>用户可以根据本条款以及本公司不时更新和公布的其他规则(包括但不限于本公司在官方网站上公布GM服务政策、外挂处理流程、盗号处理流程等)使用本公司提供的产品和服务。</p>
				<p>用户有权在使用本公司提供的产品和服务的期间监督本公司及本公司的工作人员是否按照本公司所公布的标准向用户提供产品和服务，也可以随时向本公司提出与本公司的产品和服务有关意见和建议。</p>
				<p class="title">第二条&nbsp;资费政策</p>
				<p>有关产品和服务的收费标准、购买方式等信息本公司将会放置在该产品和服务网页的相应位置。</p>
				<p>本公司将有权决定本公司所提供的产品和服务的资费标准和收费方式，本公司可能会就不同的产品和服务制定不同的资费标准和收费方式，也可能按照本公司所提供的产品和服务的不同阶段确定不同的资费标准和收费方式。</p>
				<p class="title">第三条&nbsp;用户帐号</p>
				<p class="title-1">1.帐号的用途</p>
				<p class="title-2">a)用户可以注册一个或几个帐号用于参加本网络游戏。 </p>
				<p class="title-2">b)用户进行帐号登陆后方可参加本网络游戏。</p>
				<p class="title-2">c)用户通过购买闲逸豆进行帐号充值。</p>
				<p class="title-1">2.帐号的取得</p>
				<p class="title-2">a)用户必须完全同意全部用户条款并完成注册程序。</p>
				<p class="title-2">b)用户注册成功，得到一个会员帐号和密码，即可成为本网络游戏的正式会员。</p>
				<p class="title-2">c)注册过程中，用户应按照相关要求输入正确的个人基本资料，包括真实姓名和有效的身份证、护照、军人证号码。&nbsp;注册必须填写过防沉迷信息。用户承诺以其真实身份注册账号，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本条款的约定对所提供的信息承担相应的法律责任。</p>
				<p class="title-2">d)用户输入的姓名和身份证、护照、军人证号码结合其与之对应的证件，作为本游戏用户的唯一有效身份证明；在无法有效证明其身份时，本公司有权拒绝提供任何信息或承担任何义务。</p>
				<p class="title-1">3.帐号的修改</p>
				<p class="title-2">a)为保障用户的权益，用户无法自行修改会员帐号与证件号码。</p>
				<p class="title-2">b)用户可随时修改密码。</p>
				<p class="title-2">c)用户以其真实身份注册会员账号后，需要修改所提供的个人身份资料（包括联系方式、身份证号码等）信息的，本公司应当及时、有效地为其提供该项服务。但用户必须出示按照本公司要求出示相关的证明文件。</p>
				<p class="title-2">d)用户帐号信息发生变更而未及时修改，导致无法证明用户的有效身份，本公司有权拒绝提供任何信息或承担任何义务。</p>
				<p class="title-1">4.帐号的保护</p>
				<p class="title-2">a) 本公司有权审查用户注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。</p>
				<p class="title-2">b) 用户对登录后所持账号产生的行为依法享有权利和承担责任。如若有任何第三方向本公司发出指示，在确认其提供账户、密码信息准确的情况下，用户同意且本公司有权视为该行为获得了用户的充分授权，该行为所产生结果直接归属于用户本身；</p>
				<p class="title-2">c)用户若发现任何非法使用会员账号或存在安全漏洞的情况，请立即通知本公司。</p>
				<p class="title-2">d)若本公司发现疑似遭盗用的会员帐号，将立即终止该会员帐号的使用权。</p>
				<p class="title-2">e)本公司可以依据用户注册时提供的电子邮箱及手机号为用户查询密码。</p>
				<p class="title-2">f)若因为用户自身原因，而导致账号、密码遭他人非法使用时，本公司将不负责处理。用户自身原因包括但不限于：任意向第三者透露账号和密码及所有注册资料；多人共享同一个账号；安装非法或来路不明的程序等。</p>
				<p class="title-2">g) 若用户发现账号或密码被他人非法使用或有异常使用的情形，应立即根据本公司公布的处理方式通知本公司，并有权通知本公司暂停该账号的登录和使用，但用户在申请时应提供与其注册身份信息相一致的个人有效身份信息。本公司核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。本公司违反上述约定，未及时采取措施暂停用户账号的登录和使用，因此而给用户造成损失的，应当承担其相应的法律责任。用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，本公司有权拒绝用户上述请求。</p>
				<p class="title-1">5.帐号的制裁</p>
				<p>（1）账号制裁的方式：</p>
				<p>本公司将按照本《条款》及相关服务政策、外挂处理流程、盗号处理流程等具体规定，对违反该些游戏管理规定的玩家给予账号制裁，包括但不限于冻结、删除账号。</p>
				<p>（2）账号的冻结——中止服务</p>
				<p>用户同意在用户有下列情况下，本公司可以冻结用户注册的账号，中止向用户提供产品和服务：</p>
				<p class="title-2">a)违反本合约的规定。</p>
				<p class="title-2">b)提供虚假注册身份信息。</p>
				<p class="title-2">c)损害其他用户的行为但不构成严重情形。</p>
				<p>若本公司根据上述第（a）项和第（b）项情形做出中止对用户提供全部或部分服务的决定，则应告知用户中止期间，中止期间应该是合理的，中止期间届满本公司应当及时恢复对用户的服务。但中止期间届满时，用户的违约状态仍然存在的，本公司有权延长中止服务的期间。</p>
				<p>本公司依据上述第（a）、（b）项规定中止对用户服务时，本公司应负初步举证责任。</p>
				<p>（3）帐号的删除——终止服务</p>
				<p>用户同意在用户有下列情况下，本公司可以立即删除用户注册的账号，终止向用户提供产品和服务：</p>
				<p class="title-2">a)发布违法信息。</p>
				<p class="title-2">b)严重违背社会公德、以及其他违反法律禁止性规定.</p>
				<p class="title-2">c)滥用所享有的权利。</p>
				<p class="title-2">d)通过非法手段、不正当手段或其他不公平的手段使用本公司的产品和服务或参与本公司活动。</p>
				<p class="title-2">e)有损害本公司正当利益的行为。</p>
				<p class="title-2">f)有严重损害其他用户的行为。</p>
				<p class="title-2">g)其他妨碍本公司提供产品和服务或本公司认为的严重不当行为。</p>
				<p class="title-2">h) 除上述情况外，用户在接受本公司服务时实施了其他不正当行为的。用户实施的不正当行为仅指在本条款中有明确约定或属于本公司事先明确告知的禁止性行为，否则，本公司不得根据本情况的规定做出终止对用户的服务的决定。</p>
				<p class="title-2">g)以上a/b/c/d/e/f几种情况都不出现的情况下，对于充值用户本公司将一直保留其账号，非充值用户（最后一次充值往后延6个月视为非充值用户）本公司将保留随时删除其账号及相关信息的权利。</p>
				<p>本公司依据上述第（a）、（b）、（h）项规定终止对用户服务时，本公司应负初步举证责任。同一用户注册的账号中有一个账号或多个账号出现违反本条款约定的行为，本公司有权根据实际情况，中止、终止对该用户名下部分或所有账号的服务，或取消该用户名下部分或所有账号。</p>
				<p>本公司因上述原因删除用户注册的账号后即不再对用户承担任何义务和责任。</p>
				<p class="title">第四条&nbsp;本公司的义务</p>
				<p>1.本公司通过国际互联网络为用户提供网络服务。</p>
				<p>2.严格按照《北京博久网络科技有限公司用户信息保密政策》的约定对用户信息承担保密义务。</p>
				<p class="title-1">3.&nbsp;本公司在此特别提示用户：　</p>
				<p class="title-1">基于软件产品本身的特殊性及本《条款》责任限制条款所述，尽管本公司将尽最大努力解决已知的漏洞和错误（Bug），但用户知道或应该知道本产品仍可能包含未知的漏洞和错误（Bug）等。</p>
				<p>4. 用户为了维护其合法权益，向本公司提供与所注册的身份信息相一致的个人有效身份信息时，本公司应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
				<p class="title">第五条&nbsp;用户的义务</p>
				<p class="title-1">用户应：</p>
				<p>1.自行配备上网的所需设备，包括但不限于电脑、调制解调器或其他必备上网装置。</p>
				<p>2.自行负担上网所支付的与此服务相关的电话费用、网络使用费用。</p>
				<p>3.提供详尽、准确的个人资料并不断更新个人资料。<span>如果因为用户提供的资料包含有不正确的信息，导致用户不能正常使用该款网络游戏，本公司不承担任何责任。</span></p>
				<p>4.遵守游戏公约、玩家守则(包括但不限于本公司在官方网站上公布GM服务政策、外挂处理流程、盗号处理流程等)。</p>
				<p>5.遵守中华人民共和国相关法律法规(如果用户是中华人民共和国境外的使用者，应遵守所属国家或地区的法律法规)。用户将自行承担用户所发布的信息内容的责任。特别地，用户不得发布下列内容：</p>
				<p class="title-2">(a) 反对中华人民共和国宪法所确定的基本原则的；</p>
				<p class="title-2">(b) 危害国家统一、主权和领土完整的；</p>
				<p class="title-2">(c) 泄露国家秘密，危害国家安全或者损害国家荣誉和利益的；</p>
				<p class="title-2">(d) 煽动民族仇恨、民族歧视，破坏民族团结或者侵害民族风俗、习惯的；</p>
				<p class="title-2">(e) 破坏国家宗教政策，宣扬邪教、迷信的；</p>
				<p class="title-2">(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
				<p class="title-2">(g) 散布淫秽、赌博、暴力或者教唆犯罪的；</p>
				<p class="title-2">(h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
				<p class="title-2">(i) 危害社会公德或者民族优秀文化传统的；</p>
				<p class="title-2">(j) 宣扬外挂,私服以及木马的相关内容；</p>
				<p class="title-2">(k) 刊登任何经本公司合理判断为不妥当或者本公司未认可的软件、文件等在内的主页地址或者链接的行为；</p>
				<p class="title-2">(l)含有中华人民共和国法律、行政法规禁止的其他内容的。&nbsp;</p>
				<p>6 用户不得通过不正当的手段或其他不公平的手段使用本公司的产品和服务或参与本公司活动。用户不得干扰本公司正常地提供产品和服务，包括但不限于：攻击、侵入本公司的网站服务器或使网站服务器过载；破解、修改本公司提供的客户端程序；攻击、侵入本公司的游戏服务器或游戏服务器端程序或使游戏服务器过载；制作、发布、传播、使用任何形式的妨碍游戏公平性的辅助工具或程序(外挂)；利用程序的漏洞和错误(Bug)破坏游戏的正常进行或传播该漏洞或错误(Bug)；不合理地干扰或阻碍他人使用本公司所提供的产品和服务。</p>
				<p>为维护游戏的公平性，如果本公司发现用户数据异常，无论用户对该异常数据产生是否负有过错，本公司均有权根据本《条款》、游戏公约、玩家守则及后期不时发布的游戏公告等，采取相应措施：包括但不限于对该账号的冻结、终止、删除；用户在此承诺本公司有权作出上述行为，并承诺不就上述行为要求本公司做任何补偿或退费。</p>
				<p class="title">第六条&nbsp;服务的中断、停止</p>
				<p>为了网站的正常运行，本公司需要定期或不定期地对网站进行停机维护，因此类情况而造成的正常服务中断、停止，用户应该予以理解，本公司则有义务尽力避免服务中断、停止或将中断、停止时间限制在最短时间内；</p>
				<p>发生下列情形之一时，本公司有权停止或中断游戏服务器所提供之服务，对因此而产生的不便或损害，本公司对用户或第三人均不承担任何责任：</p>
				<p class="title-2">a)定期检查或施工，更新软硬件等，本公司有权暂停服务，但本公司会尽快完成维护、更新工作；</p>
				<p class="title-2">b)服务器遭受损坏，无法正常运作；</p>
				<p class="title-2">c)突发性的软硬件设备与电子通信设备故障；</p>
				<p class="title-2">d)网路提供商线路或其它故障；</p>
				<p class="title-2">e)在紧急情况之下为维护国家安全或其它会员及第三者之人身安全；</p>
				<p class="title-2">f)不可抗力及其他第三方原因。</p>
				<p>除前款所述情形外，用户同意本公司享有通过在提前60天本网络游戏官方网站公告通知的方式中断或终止部分或全部网络服务的权利，用户已明确知晓上述权利的授予且知晓因上述权利的行使可能给自身及其他第三方造成的直接或间接利益减损，用户在此明确表示不追究本公司因行使上述单方中断或终止服务权利而可能导致的一切责任。</p>
				<p class="title">第七条&nbsp;责任限制</p>
				<p>对于本公司的产品和服务，本公司仅作下述有限保证，该有限保证取代任何文档、包装、或其他资料中的任何其他明示或默示的保证(如果有)。</p>
				<p>本公司仅以&nbsp;"现有状况且包含所有错误"的形式提供相关的产品、软件或程序及任何支持服务，并仅保证:</p>
				<p>(1)本公司所提供的产品和服务能基本符合本公司正式公布的要求，</p>
				<p>(2)本公司所提供的相关产品和服务基本与本公司正式公布的服务承诺相符，</p>
				<p>(3)本公司仅在商业上允许的合理范围内尽力解决本公司在提供产品和服务过程中所遇到的任何问题。</p>
				<p>在适用法律允许的最大范围内，本公司明确表示不提供任何其他类型的保证，不论是明示的或默示的，包括但不限于适销性、适用性、可靠性、准确性、完整性、无病毒以及无错误的任何默示保证和责任。</p>
				<p>另外，在适用法律允许的最大范围内，本公司并不担保本公司所提供的产品和服务一定能满足用户的要求，也不担保提供的产品和服务不会被中断，并且对产品和服务的及时性，安全性，出错发生，以及信息是否能准确，及时，顺利的传送均不作任何担保。</p>
				<p>在适用法律允许的最大范围内，本公司不就因用户使用本公司的产品和服务引起的，或在任何方面与本公司的产品和服务有关的任何意外的、非直接的、特殊的、或间接的损害或请求(包括但不限于因人身伤害、因隐私泄漏、因未能履行包括诚信或合理谨慎在内的任何责任、因过失和因任何其他金钱上的损失或其他损失而造成的损害赔偿)承担任何责任。</p>
				<p>用户在本网络游戏官方网站上所表达的观点、建议和其它内容均为用户本人看法，不代表本公司的观点。</p>
				<p>本公司保留采取包括但不限于合并服务器等形式以达到服务器资源优化利用的权利，如发生上述情形，本公司有义务保障用户资料的完整性。</p>
				<p class="title">第八条&nbsp;变更</p>
				<p>本公司有权在必要时修改用户条款、游戏公约和玩家守则。本公司的用户条款、游戏公约和玩家守则一旦发生变动，将会在该款网络游戏的重要页面上提示修改内容。如果用户不同意本公司修改的内容，用户可以主动取消获得的网络服务。如果用户在修改内容公告后15天内未主动取消服务，则视为接受条款的变更；修改内容公告后用户如果仍继续使用本公司提供的产品和服务亦构成对条款变更的接受。</p>
				<p class="title">第九条&nbsp;知识产权</p>
				<p>1.本款网络游戏官方网站上所有的作品及资料，其著作权、专利权、商标专用权、商业秘密权及其它知识产权，均为本公司或授权本公司使用的合法权利人所有，除非事先经本公司或其权利人的合法授权，任何人皆不得擅自以任何形式使用，否则本公司可立即终止向用户提供产品和服务，并依法追究其法律责任，赔偿本公司一切损失。</p>
				<p>2.未经本公司授权，任何人不得擅自复制、反编译(de-compile)、反汇编(disassemble)任何功能或程序，不得对任何功能和或程序进行反向工程(reverse engineering)。</p>
				<p class="title">第十条&nbsp;通知</p>
				<p>本公司所有发给用户的通知可通过重要页面的公告或电子邮件或常规的信件传送。</p>
				<p class="title">第十一条&nbsp;授权</p>
				<p>用户原创作品上载、传送、输入或以其他方式提供至该款网络游戏官方网站时，视为户授予本公司对其作品的使用权，该授权无地域、期限、方式限制，该授权为免费授权，本公司可在现行法律范围内就该作品进行使用，包括但不限于复制、发行、出租、展览、表演、放映、广播、信息网络传播、摄制、改编、翻译、汇编等，并可将前述权利转、分授权给其他第三方。</p>
				<p class="title">第十二条&nbsp;纠纷</p>
				<p>1.本用户条款适用中华人民共和国的法律。</p>
				<p>2.如本公司服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款法律效力不变。</p>
				<p>3.纠纷处理方式</p>
				<p>（1）用户之间纠纷处理方式</p>
				<p>a)本公司仅作为本网络游戏的运营商，如若本网络游戏用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决，包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。本公司将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。</p>
				<p>b)本网络游戏用户之间发生纠纷的，也可向本公司的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他本公司要求提供的相关证据。经本公司审核确认后，可以给予必要的协助和支持。</p>
				<p>（2）用户与本公司之间纠纷处理方式</p>
				<p class="title-2">　a)如本网络游戏用户对本公司的服务有任何异议的，可以向本公司的客服人员投诉并举证。查证属实的，本公司将立即更正并按照现行法律规定给予用户必要的补偿。</p>
				<p class="title-2">　b)如本网络游戏用户对本公司的服务有任何异议的，向本公司所在地人民法院提起诉讼。</p>
			</div>
     </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}

a, a:active, a:visited, a:hover, a:target {
    display: inline-block;
}

.banners{
  height: 130px;
  background: url(../../assets/images/agreement-bg.jpg) no-repeat center;
  background-size: cover;
}

.c-container{
	width: 100%;
}

.dh-content{
	position: relative;
	max-width: 512px;
	top: -40px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 25px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);
}
.ag-content{
	position: relative;
	width: 100%;
	top: 10px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 80px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);	
}
.dh-content h1,.ag-content h1{
	text-align: center;
	font-size: 13px;
	color: #333;
	margin-bottom: 10px;
}
.dh-content p,.ag-content p{
	line-height: 18px;
  font-size: 8px;
}
.dh-content p span,.ag-content p span{
	color: #000;
	font-weight: bold;
}
.dh-content p.title,.ag-content p.title{
	color: #000;
	font-weight: bold;
}
.dh-content p.title-1,.ag-content p.title-1{
	color: #000;
	font-weight: bold;
}


@media (max-width:800px) {
  .dh-content{
    top: 0;
    
  }
}

</style>
